<template>
    <div id="cookie-declaration" class="m-4"></div>
</template>
<script>
    export default {
        components: {},
        mounted() {
            let script = document.createElement('script')
            script.setAttribute('id', 'CookieDeclaration')
            script.setAttribute('src', 'https://consent.cookiebot.com/22edf4a7-da34-404f-841b-b6410f9f56b1/cd.js')
            document.getElementById('cookie-declaration').appendChild(script)
        }
    }
</script>